import Dot3Icon from "../../gui/Icons/Dot3Icon";
import { TMenuRow } from "../../gui/Menu/Menu";
import MenuButton from "../../gui/Menu/MenuButton";
import DateRangeFilter from "../widgets/DateRangeFilter";
import AccountFilter from "../widgets/AccountFilter";
import SearchFilter from "../widgets/SearchFilter"
import { usePath } from "../../libs/path/PathProvider";
import { Price } from "../../models/Price";

export type TTransactionsToolbarProps = {
    search:string
    onSearch:(search:string) => void
    onExport:() => void
}
export default function TransanctionsToolbar(props:TTransactionsToolbarProps){
    const {hash} = usePath()
    const [_,ticker] = hash.split("/")
    const isCash = Price.isCash(ticker)
    const MenuOptions : TMenuRow<string>[] = [
        {id:"add",text:isCash ? "Deposit/Withdraw" : "Acquisition", url:{hash:`/${ticker}/add`}},
        {id:"div",text:Price.isCash(ticker) ? "Interest/Adjust" : "Dividend", url:{hash:`/${ticker}/dividend`}},
        {id:"export",text:"Export", onClick:props.onExport}
    ]
    if (!isCash) {
        MenuOptions.push({id:"reinvest",text:"Reinvest",url:{hash:`/${ticker}/reinvest`}})
    }
    return <div className="toolbar flex middle gap-8">
        <AccountFilter/>
        <SearchFilter search={props.search} onSearch={props.onSearch}/>
        <DateRangeFilter/>
        <MenuButton menuProps={{options:MenuOptions}} className="icon"><Dot3Icon/></MenuButton>
    </div>
}